var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIUpload = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.581 -250.499)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(-79.581 250.499)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.036 84.611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-87.062,184.958h0a.5.5,0,0,1-.5-.5,4.516,4.516,0,0,0-1.326-3.213,4.5,4.5,0,0,0-3.206-1.329l-12.59.007h0a.5.5,0,0,1-.354-.147l-4.888-4.888h-9.863a2.02,2.02,0,0,0-2.017,2.017v7.553a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5V176.9a3.02,3.02,0,0,1,3.017-3.017h10.07a.5.5,0,0,1,.353.146l4.889,4.889,12.383-.007a5.5,5.5,0,0,1,3.913,1.622,5.507,5.507,0,0,1,1.619,3.92A.5.5,0,0,1-87.062,184.958Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.511,205.1h-22.347a5.526,5.526,0,0,1-5.369-4.194l-3.3-13.2a3,3,0,0,1-.09-.731,2.993,2.993,0,0,1,.883-2.134,3,3,0,0,1,2.134-.884l33.831,0a3.019,3.019,0,0,1,.732.09,3.021,3.021,0,0,1,2.2,3.659l-3.3,13.2A5.527,5.527,0,0,1-93.511,205.1Zm5.742-20.147-33.831,0a2.005,2.005,0,0,0-1.427.591,2,2,0,0,0-.59,1.427,2.016,2.016,0,0,0,.061.489l3.3,13.2a4.527,4.527,0,0,0,4.4,3.436h22.347a4.527,4.527,0,0,0,4.4-3.436l3.3-13.2a2,2,0,0,0-.228-1.527,2,2,0,0,0-1.24-.919A2.036,2.036,0,0,0-87.769,184.951Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101.427,193.1a.5.5,0,0,1-.355-.148l-2.886-2.9-2.92,2.9a.5.5,0,0,1-.707,0,.5.5,0,0,1,0-.707l3.275-3.257a.5.5,0,0,1,.352-.145h0a.5.5,0,0,1,.354.147l3.238,3.257a.5.5,0,0,1,0,.707A.5.5,0,0,1-101.427,193.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.666,199.611a.5.5,0,0,1-.5-.5v-9.752a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v9.752A.5.5,0,0,1-104.666,199.611Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_upload.f91bda7c.svg";
export { ForwardRef as ReactComponent };